/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Reason_Reviewed_TitleInputs */



/**
* | output |
* | --- |
* | "Every report reviewed" |
*
* @param {Home_Reason_Reviewed_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const home_reason_reviewed_title = /** @type {((inputs?: Home_Reason_Reviewed_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Reason_Reviewed_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("每份报告都经过审核")
	return /** @type {LocalizedString} */ ("Every report reviewed")
});